export function tryParseHexColor(color: string): {
  red: number
  green: number
  blue: number
} | null {
  const normalized = color.startsWith('#') ? color.slice(1) : color
  const isSixDigitHex = normalized.length === 6
  if (!isSixDigitHex) return null

  const red = Number.parseInt(normalized.slice(0, 2), 16)
  const green = Number.parseInt(normalized.slice(2, 4), 16)
  const blue = Number.parseInt(normalized.slice(4, 6), 16)

  const isValidRgbChannel = [red, green, blue].every((channel) =>
    Number.isFinite(channel)
  )
  if (!isValidRgbChannel) return null

  return { red, green, blue }
}

export function getMutedBackgroundFromIndicatorColor(
  indicatorColor: string
): string {
  const rgb = tryParseHexColor(indicatorColor)
  if (!rgb) return '#f5f5f5'
  return `rgba(${rgb.red}, ${rgb.green}, ${rgb.blue}, 0.14)`
}
